export default __webpack_public_path__ + "static/media/track-everything.d3944b13.gif";